import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DiagramForkBtn',
  props: {
  disabled: Boolean,
  backButton: Boolean,
  iconSize: {
    type: Number,
    required: false,
    default: 24,
  },
  diagramUrl: {
    type: String,
    required: true,
  },
},
  emits: ['forkDiagramPressed'],
  setup(__props, { emit }) {

const props = __props;

// ------ Props ------


// ------ Emits ------


// ------ Methods ------
function goToMyMachinationDiagram() {
  window.open(props.diagramUrl);
  emit('forkDiagramPressed');
}

return { __sfc: true,props, emit, goToMyMachinationDiagram }
}

})